import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, Link, Navigate, useSearchParams } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../../components/imports'

import { HeaderProfile, ProfileMenu } from '../../components/profile-prive'

import { WEBROOT, APP_NAME } from '../../constants/general'

import { Context } from '../../class/Context'

import Func from '../../class/Func'

import Paiements_Class from '../../class/Paiements_Class'
import Moment from 'react-moment';

function PorteMonnaie() {

    const navigate = useNavigate();

    const context = useContext(Context)

    const [get_params] = useSearchParams()

    const [flash, setFlash] = useState('')

    const [data, setData] = useState(false)

    const [balance, setBalance] = useState(0)

    const [transactions, setTransactions] = useState([])

    const [addIban, setAddIban] = useState(false)

    const [loading, setLoading] = useState(false)

    const [isPayout, setIsPayout] = useState(true)

    const [compte_cree, setCompteCree] = useState(false)

    const userPaiements = async () => {

        let results = await Paiements_Class.paiements('?iban=true&payouts=true')

        if (results.success) {

            // if (results.UserCategory == 'OWNER' && results.UserStatus == 'PENDING_USER_ACTION') {

            //     navigate('/mon-profile/passer-owner?status=pending')

            //     return false

            // } else {

            setData(results)

            setBalance(results.balance_available)

            setTransactions(results.payouts.reverse())

            // A Supprimer
            // setData({
            //     "balance": "25.00",
            //     "balance_int": 25,
            //     "iban": "LT463500010003167710",
            //     "kyc_paiement" : "1",
            //     "kyc_active" : "0"
            // })
            // A Supprimer

            // if (typeof results.transactions === "string") {
            //     setTransactions(results.transactions)
            // } else {
            //     setTransactions(results.transactions.reverse())
            // }

        }

        // } else {

        //     setFlash({ message: results.message, type: "error" })

        // }

        window.scrollTo(0, 0)

    }

    const payout = async () => {

        setIsPayout(false)

        let results = await Paiements_Class.payout()

        console.log(results)

        if (results.success) {

            setFlash({ message: results.message, type: "succes" })

            userPaiements()

        } else {

            setFlash({ message: results.message, type: "error" })

        }

        window.scrollTo(0, 0)

        setIsPayout(true)

    }

    const editIban = async (e) => {

        e.preventDefault()

        setLoading(true)

        let inputs = e.target

        let iban = inputs.iban.value
        let name = inputs.name.value

        let results = await Paiements_Class.addIban(iban, name)

        if (results.success) {

            setFlash({ message: results.message, type: "succes" })

            setAddIban(false)

            userPaiements()

        } else {

            setFlash({ message: results.message, type: "error" })

        }

        window.scrollTo(0, 0)

        setLoading(false)

    }

    // const masquerChaine = (chaine) => {
    //     const debut = chaine.slice(0, 4); // Les 4 premiers caractères
    //     const fin = chaine.slice(-4);    // Les 4 derniers caractères
    //     return `${debut}****${fin}`;
    // }

    const connectAccount = async () => {

        setLoading(true)

        let results = await Paiements_Class.post('connect_account', { 'stripe_connect_id': true })

        if (results.success) {

            // window.location.href = results.url

            window.open(results.url, '_blank');

        } else {

            alert('impossible de créer un compte vendeur')

        }

        setLoading(false)

    }

    useEffect(() => {

        let compte_cree = get_params.get("done")

        if (compte_cree != null) setCompteCree(true)

        Func.session(context, navigate)

        Func.getFlash(setFlash)

        userPaiements()

        document.title = "Porte Monnaie - " + APP_NAME

    }, [])

    return (

        <div>

            <Header />

            <div className="profil">

                <HeaderBox />

                <div className='content pos-r'>

                    <div className="c">

                        <HeaderProfile />

                    </div>

                    <div className="mt30">

                        <div className="c pos-r">

                            <ProfileMenu data="porte-monnaie" />

                            {(flash !== '') && <p className={flash.type}>{flash.message}</p>}

                            {

                                compte_cree == true

                                &&

                                <p className='succes'>Compte créé avec succès, tu peux vendre tes plantes ou proposer tes services de Plant-sitter / Jardinier sur Sisters Green</p>
                            }

                            {

                                data == false || loading == true

                                    ?

                                    <div className='flex jc-center mt50 mb50'>
                                        <div className="lds-dual-ring col"></div>
                                    </div>

                                    :

                                    <div className="paiements">

                                        {

                                            data.account_verified !== true

                                            &&

                                            <div className="bg6 p20 br10 pt60">

                                                <div>
                                                    <p className='d-block fz11 mb10'>Pour vendre des plantes ou proposer tes services de Plant-sitter / Jardinier sur Sisters Green,</p>
                                                    <p className='d-block fz11 mb10'>tu dois créer <strong>gratuitement</strong> un compte vendeur sécurisé via Stripe.</p>
                                                    <p className='d-block fz09 mb10'>Stripe est notre partenaire de paiement et garantit le versement de tes gains en toute sécurité.</p>
                                                    <p className='d-block fz09 mb50'>Pourquoi Stripe est-il obligatoire ? Consulte notre <Link to={'/page/informations-paiement-securise'} target='_blank' className='cl2 fw6'>FAQ paiements</Link></p>
                                                </div>

                                                <div className='m_mt_30 ta-start'>

                                                    <span className='btn bg3 cl1' onClick={connectAccount}>Créer un compte</span>

                                                    <div className='mt20'>

                                                        <p className='d-block fz08 mb10'>Lors de l’inscription, certaines informations “Entreprise” peuvent apparaître (interface standard de Stripe).</p>
                                                        <p className='d-block fz08 mb10'>Si tu es un particulier, tu n'as rien à modifier. Vérifie simplement tes informations personnelles puis clique directement sur “Accepter et envoyer”</p>

                                                    </div>

                                                </div>

                                            </div>

                                        }

                                        {

                                            data.account_verified == true

                                            &&
                                            <>

                                                {

                                                    data.stripe_connect_id !== null

                                                    &&

                                                    <>

                                                        <div className="bg6 p20 br10 mb20 flex ai-center">

                                                            <div>

                                                                <span className='d-block fw6 fz11'>Solde disponible en cours de transfert</span>

                                                                {/* <span className='d-block'>Montant à transférer en attente : {parseFloat(data.balance_pending).toFixed(2)} €</span> */}

                                                                <span className='d-block'>Clique sur <Link to={'https://stripe.com/fr/resources/more/general-terms-and-conditions-of-sale-france'} target='_blank' className='cl2 fw6'>CGU</Link> pour plus d'informations.</span>


                                                            </div>

                                                            <div className='m_mt_10'>

                                                                <p className='fz2 ta-end m_ta_left'>{parseFloat(balance).toFixed(2)} €</p>

                                                                {/* {

                                                                    parseFloat(balance) >= 1

                                                                        ?

                                                                        isPayout

                                                                            ?

                                                                            <span className='btn bg4 cl1' onClick={payout} title="Transférer vers mon compte">Transférer vers mon compte</span>

                                                                            :

                                                                            <span className='btn bg4 cl1'>Demande de transfert en cours ...</span>

                                                                        :

                                                                        <></>

                                                                } */}

                                                            </div>

                                                        </div>

                                                        {/* <div className="bg6 p20 br10 mb20 flex ai-center">

                                                            <div>

                                                                <span className='d-block'>Montant à transférer en attente : {parseFloat(data.balance_pending).toFixed(2)} €</span>

                                                            </div>

                                                            <div className='m_mt_10'>

                                                                {/* <p className='ta-end m_ta_left'></p> */}

                                                        {/* <span onClick={connectAccount} target='_blank' className='btn bg3 cl1 fz1'>Accéder compte</span> */}

                                                        {/* </div>

                                                        </div> */}

                                                    </>

                                                }

                                                {/* {

                                                    data.stripe_connect_id !== null

                                                    &&

                                                    <div className='grid2'>
                                                        <div className="bg6 p20 br10 mb20">
                                                            <div className="flex ai-center m_flex">
                                                                <div>
                                                                    <span className='d-block'>Recevoir des paiement {data.account_verified == true ? <span className='cl4'>(VALIDÉ)</span> : <span className='cl3'>(NON VALIDÉ)</span>}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="bg6 p20 br10 mb20">
                                                            <div className="flex ai-center m_flex">
                                                                <div>
                                                                    <span className='d-block'>Recevoir des virement {data.account_verified == true ? <span className='cl4'>(VALIDÉ)</span> : <span className='cl3'>(NON VALIDÉ)</span>}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                } */}

                                                {
                                                    data.iban !== false

                                                        ?

                                                        <div className="bg6 p20 br10 mb20 flex ai-center mb40">

                                                            <div>
                                                                <p className='d-block'>IBAN enregistré (****{data.iban.iban}) {data.iban.bank_name} ({data.iban.country})</p>
                                                                <span className='fz08'>En cliquant sur <span className='cl3'>Modifier IBAN</span>, tu accèdes aux <strong>paramètres</strong>. En bas de la page, tu peux ajouter un nouvel IBAN ou moodifier celui éxistant</span>
                                                            </div>

                                                            {/* <span className='btn bg3 cl1' onClick={() => setAddIban(true)}>Modifier IBAN</span> */}

                                                            <span onClick={connectAccount} target='_blank' className='btn bg3 cl1 fz1 m_mt_20'>Modifier IBAN</span>

                                                        </div>

                                                        :

                                                        <div className="bg6 p20 br10 mb20 flex">

                                                            <span onClick={connectAccount} target='_blank' className='btn bg3 cl1 fz1'>Ajouter IBAN</span>

                                                            {/* <span className='btn bg3 cl1' onClick={() => setAddIban(true)}>Ajouter IBAN</span> */}

                                                        </div>

                                                }

                                                {/* {

                                                    addIban == true

                                                    &&

                                                    <div className='gla-form bg6 p20 br10 mb20' id='parametres'>

                                                        <p>En cliquant sur <span onClick={connectAccount} target='_blank' className='cl3 cur_p'>Modifier IBAN</span>, tu accèdes aux <strong>paramètres</strong>. En bas de la page, tu peux ajouter un nouvel IBAN ou moodifier celui éxistant</p>

                                                    </div>

                                                } */}

                                                {/* {

                                                    addIban

                                                    &&

                                                    <form method='POST' className='gla-form bg6 p20 br10 mb20' onSubmit={(e) => editIban(e)} id='parametres'>

                                                        <h3 className='mb30 fw3'>Mon compte</h3>


                                                        <label className='col-5'>
                                                            <span>Nom du titulaire du compte</span>
                                                            <div><input type='text' name='name' placeholder="Nom et prénom" minLength="6" maxLength="64" required={true} style={{ border: '1px solid #666', width: '300px' }} /></div>
                                                        </label>

                                                        <label className='col-5'>
                                                            <span>IBAN</span>
                                                            <div><input type='text' name='iban' placeholder='FR********' minLength="27" maxLength="34" required={true} style={{ border: '1px solid #666', width: '300px' }} /></div>
                                                        </label>

                                                        {

                                                            loading

                                                                ?

                                                                <div className="lds-dual-ring col"></div>

                                                                :

                                                                <div className="ta-end">
                                                                    <input type="submit" name="submit" value="Enregistrer" className="btn cl1 bg4 brc4 brc2solid fw5" />
                                                                </div>

                                                        }

                                                    </form>

                                                } */}

                                                {transactions.length > 0 && <h3 className='mb20 fw5'>Paiements sur mon compte</h3>}

                                                {

                                                    typeof transactions === "string"

                                                        ?

                                                        <p className='fz09'>{transactions}</p>

                                                        :

                                                        <>



                                                            {

                                                                transactions.map(transaction =>

                                                                    <div className="trans bg6 cl2 pl20" key={transaction.id}>

                                                                        <div className='infos'>

                                                                            <span className='t cl2 fw6'>{parseFloat(transaction.amount / 100).toFixed(2)} €</span>
                                                                            {/* {transaction.Fees.Amount > 20 && <span className='t cl2'>Frais KYC {(transaction.Fees.Amount - 20) / 100} €</span>} */}

                                                                            {transaction.status == 'paid' && <span className='t' style={{ color: '#6eab69' }}>VALIDÉ</span>}

                                                                        </div>

                                                                        {transaction.created != 0 && <span className='date'><Moment locale="fr" format='DD MMMM Y' unix={transaction.created}>{transaction.created}</Moment></span>}

                                                                    </div>

                                                                )

                                                            }

                                                        </>

                                                }

                                            </>

                                        }

                                    </div>

                            }

                        </div>
                    </div>
                </div>

            </div>

            <Footer />

        </div >

    )

}

export default PorteMonnaie